/**
 * @description: 阻止冒泡
 * @param {Event}
 */
var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};
/**
 * @description: 阻止默认行为
 * @param {Event, Boolean}
 */
function preventDefault(event, isStopPropagation) {
  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
    event.preventDefault();
  }
  if (isStopPropagation) {
    stopPropagation(event);
  }
}
/**
 * 获取指定dom节点的translate信息
 * @param dom
 */
function getTranslateOffset(dom) {
  var computedStyle = getComputedStyle(dom);
  var transform = computedStyle.transform;
  var values = transform.replace(/matrix| |3d|\(|\)/g, '').split(',');
  // 参考：https://zellwk.com/blog/css-translate-values-in-javascript/
  if (transform.includes('matrix3d')) {
    return {
      x: parseFloat(values[12]),
      y: parseFloat(values[13]),
      z: parseFloat(values[14])
    };
  }
  return {
    x: parseFloat(values[4]),
    y: parseFloat(values[5]),
    z: 0
  };
}

export { getTranslateOffset, preventDefault, stopPropagation };
